<template>
  <div style='margin-top: -10px' class="container">
    <div style='border-bottom: 1px #ececec solid;padding-bottom: 10px;'>
      <el-button type="primary" @click="returnFn()">返回列表</el-button>
    </div>
    <div class='descriptionsBox'>
      <el-descriptions title="服务对象信息" :column='4'>
        <template slot="extra"><span class='extraSpan'>{{ rowData.status === 1 ? '住院中' : '已出院' }}</span></template>
        <el-descriptions-item label="姓名">{{ rowData.name }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ rowData.tel }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ rowData.idNo }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column='4'>
        <el-descriptions-item label="所在乡镇">{{ rowData.area }}</el-descriptions-item>
        <el-descriptions-item label="所在医院">{{ rowData.hospital }}</el-descriptions-item>
        <el-descriptions-item label="自理能力评估">
          <span v-if='rowData.selfcareAbility == 1'>完全自理</span>
          <span v-if='rowData.selfcareAbility == 2'>部分自理</span>
          <span v-if='rowData.selfcareAbility == 3'>不能自理</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column='4'>
        <el-descriptions-item label="住院日期">{{ rowData.enter }}</el-descriptions-item>
        <el-descriptions-item label="出院日期"> {{ rowData.status === 2 ? rowData.leave : '' }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions>
        <el-descriptions-item label="具体楼宇、科室、楼层、病床号">{{ rowData.address }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions>
        <el-descriptions-item label="服务对象照片">
          <div class="imgbox">
            <el-image class='litimg' v-for="img in rowData.img" :src="img" :preview-src-list="rowData.img" />
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class='mt30' title="申请人信息" :column='5'>
        <el-descriptions-item label="姓名">{{ rowData.applicantName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ rowData.applicantPhone }}</el-descriptions-item>
        <el-descriptions-item label="申请人与服务对象关系">{{ rowData.applicantRelationship }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions class='mt30' title="护理记录" :column='1'>
        <template slot="extra">
          <el-button v-if='rowData.status === 1' type="primary" @click="showEditDialog(rowData)">添加护理记录</el-button>
        </template>
      </el-descriptions>
      <div class='tableBoxW'>
        <div class='tableBox'>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="status" minWidth="120" >
              <template slot-scope="scope">
                <div :style='(scope.row.status === "已结束")? "color: red":""'>{{ scope.row.status }}</div>
              </template>
            </el-table-column>
            <el-table-column minWidth="180">
                <template slot-scope="scope">
                  <div>{{ scope.row.nurse }}</div>
                  <div>{{ scope.row.nurse_tel }}</div>
                  <div>开始时间：{{ scope.row.startDate }}</div>
                </template>
            </el-table-column>
            <el-table-column minWidth="120">
              <template slot-scope="scope">佣金:{{ scope.row.brokerage }}</template>
            </el-table-column>
            <el-table-column minWidth="220">
              <template slot-scope="scope">
                <div>服务中照片:</div>
                <div class="imgbox">
                  <el-image class='litimg2'
                    v-for="img in scope.row.inServicePicture"
                    :src="img"
                    :preview-src-list="scope.row.inServicePicture">
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column minWidth="120">
              <template slot-scope="scope">
                <div v-if='!!scope.row.modificationTime && scope.row.status !== "已结束" '>
                  <span v-if='(Date.parse((scope.row.modificationTime).replace(/-/g, "/")) > thisDate)'>今日已更新</span>
                  <span style='color: red' v-if='!(Date.parse((scope.row.modificationTime).replace(/-/g, "/")) > thisDate)'>今日未更新</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="isAdmin" width="60">
              <template slot-scope="scope">
                <div v-if='(scope.row.status === "已结束"&& rowData.status === 1)' style='color: red;cursor:pointer;' @click="deleteRecord(scope.row)">删除</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :title="editFormTitle" :visible.sync="editVisible" width="600px" center>
      <el-form :model="editForm">
        <el-form-item label="护理员姓名" :label-width="formLabelWidth">
          <el-input v-model="editForm.nurse" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="护理员手机号" :label-width="formLabelWidth">
          <el-input v-model="editForm.nurse_tel" autocomplete="off" @input='inputFn("nurse_tel")'></el-input>
        </el-form-item>
        <el-form-item label="护理中照片" :label-width="formLabelWidth" label-position="top">
          <el-upload
            action='#'
            :http-request="uploadFile"
            list-type="picture-card"
            :limit="9"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class='tipsBox'>*最多可传9张</div>
        </el-form-item>
        <el-form-item label="护理员佣金/天" :label-width="formLabelWidth">
          <el-input v-model="editForm.brokerage" placeholder="请输入护理员佣金" @input='inputFn("brokerage")'></el-input>
        </el-form-item>
        <el-form-item label="服务对象自理能力评估" :label-width="formLabelWidth">
          <el-select class='w100' v-model="editForm.selfcareAbility" placeholder="请选择活动区域">
            <el-option label="请选择..." value=""></el-option>
            <el-option label="完全自理" value="1"></el-option>
            <el-option label="部分自理" value="2"></el-option>
            <el-option label="不能自理" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pictureCompress from 'picture-compressor'
import { serviceList, serviceEdit, uploadImgs } from '@/api'
import { color } from 'mockjs/src/mock/random/color'
import { isAdmin } from '../utils/util'
export default {
  data() {
    const isDate = new Date()
    return {
      rowDataId: '',
      fileList: [],
      thisDateS: `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()}`,
      thisDate: Date.parse(`${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} 00:00:00`),
      rowData: [],
      editVisible: false,
      editForm: {
        id: '',
        nurse: '',
        inServicePicture: '',
        brokerage: '',
        selfcareAbility: '',
        modificationTime: `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()} ${isDate.getHours()}:${isDate.getMinutes()}`,
        nurse_tel: ''
      },
      editFormTitle: '',
      formLabelWidth: '153px',
      tableDataAdd: { },
      tableData: []
    }
  },
  computed: {
    isAdmin() {
      return isAdmin()
    }
  },
  mounted() {
    this.rowDataId = (location.search).split('id=')[1]
    this.getList()
  },
  methods: {
    color,
    returnFn() { this.$router.push('/service') },
    getList() {
      const params = {
        pageSize: '10',
        pageNumber: '1',
        id: this.rowDataId
      }
      serviceList(params)
        .then(res => {
          if (res.status) {
            this.rowData = res.data.list[0]
            if (res.data.list[0].nurse) {
              const targets = res.data.list[0].targets
              const tableDataAdd = {
                status: res.data.list[0].status === 1 ? '服务中' : '已结束',
                nurse: res.data.list[0].nurse,
                brokerage: res.data.list[0].brokerage,
                startDate: targets ? targets.nurseTime : '',
                nurse_tel: res.data.list[0].nurse_tel,
                inServicePicture: res.data.list[0].inServicePicture,
                modificationTime: res.data.list[0].modificationTime
              }
              this.tableDataAdd = tableDataAdd
              if (targets) this.tableData = targets.nurseRecord ? JSON.parse(res.data.list[0].targets.nurseRecord) : []
              this.tableData.push(tableDataAdd)
            }
          } else this.rowData = []
        })
    },
    showEditDialog(row) {
      this.editVisible = true
      this.fileList = []
      this.editForm.nurse = row.nurse
      this.editForm.nurse_tel = row.nurse_tel
      this.editForm.brokerage = row.brokerage
      this.editForm.selfcareAbility = row.selfcareAbility
      this.editForm.id = row.id
      this.editFormTitle = (row.nurse && row.nurse_tel) ? '编辑护工' : '添加护工'
    },
    handleRemove(file) {
      this.fileList.map((fileData, key) => {
        if (fileData.uid === file.uid) {
          this.fileList.splice(key, 1)
        }
      })
    },
    uploadFile(item) {
      const _this = this
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      reader.onload = function() {
        pictureCompress({
          img: reader.result,
          width: 500,
          height: 500
        }).then(res => {
          const params = {
            data: res.img,
            fileName: item.file.uid
          }
          uploadImgs(params)
            .then(resp => {
              if (resp.status) {
                _this.fileList.push({ uid: item.file.uid, ...resp.data })
              }
            })
            .catch(() => {

            })
        })
      }
    },
    handleEdit() {
      this.editForm['inServicePicture'] = this.fileList.map((fileData) => fileData.url)
      if (!this.editForm.nurse) return this.$message({ message: '请填写护理员姓名！', type: 'warning' })
      if (!this.editForm.nurse_tel) return this.$message({ message: '请填写护理员手机号！', type: 'warning' })
      if (!this.editForm.inServicePicture.length) return this.$message({ message: '请上传护理中照片！', type: 'warning' })
      if (!this.editForm.brokerage) return this.$message({ message: '请填写护理员佣金！', type: 'warning' })
      if (!this.editForm.selfcareAbility) return this.$message({ message: '请选择服务对象自理能力评估！', type: 'warning' })
      const params = {
        ...this.editForm
      }
      const { nurse, nurse_tel, brokerage, startDate } = this.tableDataAdd
      if (params.nurse !== nurse || params.nurse_tel !== nurse_tel) {
        if (nurse) {
          const pushData = [{
            status: '已结束',
            nurse: nurse,
            brokerage: brokerage,
            startDate: startDate,
            nurse_tel: nurse_tel,
            inServicePicture: [],
            modificationTime: ''
          }]
          let nurseRecord = this.rowData.targets ? this.rowData.targets.nurseRecord : ''
          if (nurseRecord) {
            nurseRecord = JSON.parse(nurseRecord)
            nurseRecord.push(pushData[0])
          } else nurseRecord = pushData
          params['targets'] = {
            nurseRecord: JSON.stringify(nurseRecord),
            nurseTime: this.thisDateS
          }
        } else {
          params['targets'] = { nurseTime: this.thisDateS }
        }
      }
      serviceEdit(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.$router.go(0)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    deleteRecord(_Row) {
      const { nurseRecord, nurseTime } = this.rowData.targets
      const nurseRecordNew = []
      JSON.parse(nurseRecord).map((nurseData) => {
        if (nurseData.nurse !== _Row.nurse || nurseData.nurse_tel !== _Row.nurse_tel) {
          nurseRecordNew.push(nurseData)
        }
      })
      const params = {
        id: this.rowDataId,
        targets: {
          nurseRecord: JSON.stringify(nurseRecordNew),
          nurseTime: nurseTime
        }
      }
      serviceEdit(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    inputFn(_Text) {
      this.editForm[_Text] = (this.editForm[_Text]).replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.w100{width: 100%}
.mt30{margin-top: 30px}
.descriptionsBox{
  padding: 15px;
}
.extraSpan{
  font-size: 16px;
  color: #26A4B2;
  font-weight: 600;
}
.imgbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .litimg {
    width: 120px;
    height: 120px;
    margin: 5px;
    object-fit: cover;
    cursor: zoom-in;
  }
  .litimg2 {
    width: 40px;
    height: 40px;
    margin: 5px;
    object-fit: cover;
    cursor: zoom-in;
  }
}
.tableBoxW{
  overflow: hidden;
  .tableBox{
    margin-top: -50px;
  }
}
</style>
